import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { useAirlineLanding } from '../AirlineContext';
import AirportInput from './AirportInput';

export default function SwSearchWidget() {
  const navigate = useNavigate();
  const { resultsPath } = useAirlineLanding();
  const [form, setForm] = useState({
    trip: 'round',
    cabin: 'economy',
    nonstop: false,
    from: '',
    to: '',
    depart: '',
    ret: '',
    passengers: '1',
  });

  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const onSubmit = (event) => {
    event.preventDefault();
    const query = new URLSearchParams({
      trip: form.trip,
      cabin: form.cabin,
      nonstop: String(form.nonstop),
      from: form.from,
      to: form.to,
      depart: form.depart,
      return: form.trip === 'oneway' ? '' : form.ret,
      passengers: form.passengers,
    });
    navigate(`${resultsPath}?${query.toString()}`);
  };

  return (
    <section className="swp-search" id="swp-search">
      <div className="swp-shell">
        <form className="swp-search__card" onSubmit={onSubmit}>
          <h2 className="swp-sr">Search flights</h2>

          <div className="swp-search__types">
            <label>
              <input
                type="radio"
                name="swp-trip"
                checked={form.trip === 'round'}
                onChange={() => update('trip', 'round')}
              />
              Round trip
            </label>
            <label>
              <input
                type="radio"
                name="swp-trip"
                checked={form.trip === 'oneway'}
                onChange={() => update('trip', 'oneway')}
              />
              One way
            </label>
            <label>
              <input
                type="radio"
                name="swp-cabin"
                checked={form.cabin === 'economy'}
                onChange={() => update('cabin', 'economy')}
              />
              Economy
            </label>
            <label>
              <input
                type="radio"
                name="swp-cabin"
                checked={form.cabin === 'premium'}
                onChange={() => update('cabin', 'premium')}
              />
              Premium
            </label>
            <label>
              <input
                type="checkbox"
                checked={form.nonstop}
                onChange={(e) => update('nonstop', e.target.checked)}
              />
              Non-stop flights only
            </label>
          </div>

          <div className="swp-search__grid">
            <AirportInput
              id="swp-from"
              label="From"
              value={form.from}
              onChange={(value) => update('from', value)}
            />

            <AirportInput
              id="swp-to"
              label="To"
              value={form.to}
              onChange={(value) => update('to', value)}
            />

            <label className="swp-field">
              <span>Depart date</span>
              <input
                type="date"
                value={form.depart}
                onChange={(e) => update('depart', e.target.value)}
              />
            </label>

            <label className="swp-field">
              <span>Return date</span>
              <input
                type="date"
                value={form.ret}
                disabled={form.trip === 'oneway'}
                onChange={(e) => update('ret', e.target.value)}
              />
            </label>

            <label className="swp-field">
              <span>Passengers</span>
              <select
                value={form.passengers}
                onChange={(e) => update('passengers', e.target.value)}
              >
                {['1', '2', '3', '4', '5', '6+'].map((n) => (
                  <option key={n} value={n}>
                    {n} passenger{n === '1' ? '' : 's'}
                  </option>
                ))}
              </select>
            </label>

            <button type="submit" className="swp-cta swp-search__submit">
              <Search size={17} aria-hidden />
              Search flights
            </button>
          </div>

        </form>
      </div>
    </section>
  );
}
